import { Slot } from "radix-ui";
import { forwardRef, type ComponentProps } from "react";

import { cn } from "../../lib/cn";
import { buttonVariants } from "../../primitive/button";

export type BadgeButtonProps = ComponentProps<"button"> & {
  asChild?: boolean;
};

export const BadgeButton = forwardRef<HTMLButtonElement, BadgeButtonProps>(
  ({ asChild = false, className, type = "button", ...buttonProps }, ref) => {
    const Component = asChild ? Slot.Root : "button";

    return (
      <Component
        ref={ref}
        data-slot="badge-button"
        type={type}
        className={cn(
          buttonVariants({ variant: "outline", size: "sm" }),
          "h-7 rounded-full px-3 text-sm font-medium shadow-none not-disabled:cursor-pointer",
          className,
        )}
        {...buttonProps}
      />
    );
  },
);

BadgeButton.displayName = "BadgeButton";
